import React, { useEffect, useState, useRef } from 'react'
import { useFormik } from 'formik'
import { offlinePaymentValidationSchema } from '../../../Validations/offlinePaymentValidation'
import { uploadImageServer } from '../../../apis/newsApi'
import { updatePayment } from '../../../apis/paymentAPI'
const OfflinePayment = ({ userName, userEmail, slug, setSuccess }) => {
  const [loading, setLoading] = useState(false)
  const [offlineInitialValues, setOfflineInitialValues] = useState({
    name: userName || '',
    email: userEmail || '',
    document: null,
    message: ''
  })

  const formik = useFormik({
    initialValues: offlineInitialValues,
    enableReinitialize: true,
    validationSchema: offlinePaymentValidationSchema,
    onSubmit: async values => {
      setLoading(true)
      try {
        await updatePayment(values, slug)
        setSuccess('Success')
        // alert('add Loading, Save Data To Database with API & Show success message');
      } catch (error) {
        console.error('Error submitting form:', error)
      } finally {
        setLoading(false)
      }
    }
  })
  const uploadFile = async e => {
    const file = e.target.files[0]
    const formData = new FormData()
    formData.append('file', file)
    const path = await uploadImageServer(formData)
    console.log({ fileName: path.path })
    if (path) {
      formik.setFieldValue('document', path.path)
    }
  }

  return (
    <>
      <h5>IBAN / SEPA Payment</h5>
      <div>
        <form onSubmit={formik.handleSubmit} className='row g-3'>
          <div class='col-md-6'>
            <label htmlFor='name'>Name*:</label>
            <input
              id='name'
              name='name'
              type='text'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
              className='form-control'
              style={{ marginBottom: 13 }}
            />
            {formik.touched.name && formik.errors.name ? (
              <div className='text-danger'>{formik.errors.name}</div>
            ) : null}

            <label htmlFor='email'>Email*:</label>
            <input
              id='email'
              name='email'
              type='email'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              className='form-control'
              style={{ marginBottom: 13 }}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className='text-danger'>{formik.errors.email}</div>
            ) : null}

            <label htmlFor='document'>Upload Document*:</label>
            <input
              id='document'
              name='document'
              type='file'
              onChange={uploadFile}
              onBlur={formik.handleBlur}
              className='form-control'
            />
            {formik.touched.document && formik.errors.document ? (
              <div className='text-danger'>{formik.errors.document}</div>
            ) : null}
          </div>
          <div class='col-md-6'>
            <label htmlFor='message'>Message*:</label>
            <textarea
              id='message'
              name='message'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.message}
              className='form-control'
              rows={6}
            />
            {formik.touched.message && formik.errors.message ? (
              <div className='text-danger'>{formik.errors.message}</div>
            ) : null}
          </div>
          <br />
          <button
            type='submit'
            disabled={loading}
            className='btn btn-primary mb-3'
            style={{ width: 'auto' }}
          >
            {loading ? 'Submitting...' : 'Submit Payment'}
          </button>
        </form>
      </div>
    </>
  )
}

export default OfflinePayment
